/**
 * BrandGavel — custom stylised diagonal gavel matching the illustrated
 * reference (chunky cylindrical head in warm gold, wooden brown handle, soft
 * highlights). Replaces the flat lucide `Gavel` icon in header/menu/PWA
 * splash contexts so the brand mark has actual personality.
 *
 * Uses currentColor for the outline stroke so it inherits from parent — the
 * gold/brown fills are hard-coded so the mark reads consistently on any bg.
 */
export function BrandGavel({ size = 24, className = "", strokeMark = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Rotate the whole mark ~35° for the diagonal "striking" pose. */}
      <g transform="translate(32 32) rotate(-35) translate(-32 -32)">
        {/* Handle — warm walnut brown, tapered slightly toward the pommel. */}
        <path
          d="M 30 34 L 30 58 Q 32 60 34 58 L 34 34 Z"
          fill="#8a5a2b"
          stroke="#5a3a15"
          strokeWidth="1.2"
        />
        {/* Handle highlight — thin lighter strip for wood grain feel. */}
        <path d="M 31.2 36 L 31.2 55" stroke="#c58a4a" strokeWidth="0.8" strokeLinecap="round" opacity="0.85" />
        {/* Pommel bulb at bottom of handle. */}
        <ellipse cx="32" cy="59.5" rx="3.2" ry="1.8" fill="#c89f45" stroke="#5a3a15" strokeWidth="1" />

        {/* Neck rings (where handle joins head). */}
        <rect x="26" y="30" width="12" height="2.6" rx="1" fill="#5a3a15" />
        <rect x="27" y="32.4" width="10" height="1.6" rx="0.6" fill="#7a4d20" />

        {/* Gavel head — chunky cylinder, taller for extra presence. */}
        <rect
          x="10" y="12" width="44" height="18" rx="5"
          fill="#d4a648"
          stroke="#5a3a15"
          strokeWidth="1.6"
        />
        {/* End caps — slightly darker to give volumetric feel. */}
        <ellipse cx="10.5" cy="21" rx="2.8" ry="9" fill="#a67525" stroke="#5a3a15" strokeWidth="1.4" />
        <ellipse cx="53.5" cy="21" rx="2.8" ry="9" fill="#a67525" stroke="#5a3a15" strokeWidth="1.4" />

        {/* Top highlight strip on head — the "shine". */}
        <rect x="14" y="15" width="36" height="3.5" rx="1.6" fill="#ffe9a8" opacity="0.75" />
        {/* Bottom shadow strip on head — depth. */}
        <rect x="14" y="26.5" width="36" height="2" rx="0.9" fill="#8a6c1f" opacity="0.55" />
      </g>
    </svg>
  );
}

export default BrandGavel;
